/**
 * Injects GPU-only OpenUI enter keyframes once (transform + opacity).
 */

'use client'

import { OPENUI_ENTER_KEYFRAMES } from '@/lib/openui/chrome'

let injected = false

export function ensureOpenUIEnterStyles() {
  if (typeof document === 'undefined' || injected) return
  injected = true
  const style = document.createElement('style')
  style.setAttribute('data-openui-enter', 'true')
  style.textContent = OPENUI_ENTER_KEYFRAMES
  document.head.appendChild(style)
}
